export default {"src":"/_next/static/media/AkasaGreyLogo.51248308.svg","height":12,"width":15};